const tableHeaders = [
  {
    text: 'Estimate Live Month',
    value: 'estimatedLiveDate',
    align: 'start'
  },
  {
    text: 'Live Date',
    value: 'liveDate',
    align: 'start'
  },
  {
    text: 'Submission Date',
    value: 'submissionDate',
    align: 'start'
  },
  {
    text: 'IG/TikTok Handle',
    value: 'handle',
    align: 'start'
  },
  {
    text: 'Country',
    value: 'country',
    align: 'start'
  },
  {
    text: 'Bank Name',
    value: 'bankName',
    align: 'start'
  },
  {
    text: 'SWIFT Code',
    value: 'swiftCode',
    align: 'start'
  },
  {
    text: 'Bank A/C No.',
    value: 'bankAccount',
    align: 'start'
  },
  {
    text: 'Payee Name',
    value: 'username',
    align: 'start'
  },
  {
    text: 'Influencer Email',
    value: 'email',
    align: 'start'
  },
  {
    text: 'Type',
    value: 'estimationType',
    align: 'start'
  },
  {
    text: 'Amount',
    value: 'amount',
    align: 'center'
  },
  {
    text: 'GST',
    value: 'GSTAmount',
    align: 'center'
  },
  {
    text: 'Total (excluding GST)',
    value: 'GSTExcludedAmt',
    align: 'start'
  },
  {
    text: 'Campaign Name',
    value: 'campaignName',
    align: 'start'
  },
  {
    text: 'Client Name',
    value: 'clientName',
    align: 'start'
  },
  {
    text: 'Campaign IO Number',
    value: 'IONumber',
    align: 'start'
  },
  {
    text: 'CC',
    value: 'CC',
    align: 'start'
  },
  {
    text: 'Duplicate',
    value: 'duplicate',
    align: 'start'
  },
  // {
  //   text: 'Campaign - COGS-related',
  //   value: 'cogsRelated',
  //   align: 'start'
  // },
  // {
  //   text: 'Internal Claims - COGS',
  //   value: 'internalClaims',
  //   align: 'start'
  // },
  // {
  //   text: 'Logistics',
  //   value: 'logistics',
  //   align: 'start'
  // },
  // {
  //   text: 'Other Adjustment',
  //   value: 'otherAdjustment',
  //   align: 'start'
  // },
  {
    text: 'Remarks',
    value: 'remarks',
    align: 'start'
  },
  {
    text: 'Attachments',
    value: 'invoices',
    align: 'center'
  },
  {
    text: 'Action',
    value: 'action',
    align: 'center'
  }
]
const countries = [
  'Singapore',
  'Indonesia',
  'Philippines',
  'Thailand',
  'Malaysia',
  'Vietnam'
]
export default {
  tableHeaders,
  countries
}



// WEBPACK FOOTER //
// ./src/components/views/Finance/CogsEstimate/config.js